import { combineReducers } from 'redux';
import { PaginationInfo, SortValue } from 'types';
import filterReducer from './filters';
import importedOrganizationReducer from './importedOrganization';
import { ImportedOrganization, ImportedOrganizationFilters } from '../../../types/importedOrganization';
import pageInfoReducer from './pageInfo';
import sortingReducer from './sorting';

export type ImportedOrganizationsState = {
  filters: ImportedOrganizationFilters;
  importedOrganizations: ImportedOrganization[] | null;
  pageInfo: PaginationInfo;
  sorting: SortValue[];
};

const importedOrganizationsModuleReducer = combineReducers({
  filters: filterReducer,
  importedOrganizations: importedOrganizationReducer,
  pageInfo: pageInfoReducer,
  sorting: sortingReducer,
});

export default importedOrganizationsModuleReducer;
